import { useEffect, useState } from 'react';
export function useDuration(audioRef) {
  var _useState = useState(0),
      duration = _useState[0],
      setDuration = _useState[1];

  useEffect(function () {
    var audio = audioRef.current;

    var updateDuration = function updateDuration() {
      setDuration(audioRef.current.duration);
    };

    audio.addEventListener('loadedmetadata', updateDuration);
    return function () {
      return audio.removeEventListener('loadedmetadata', updateDuration);
    };
  }, [audioRef, setDuration]);
  return duration;
}